import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import injectSheet from 'react-jss';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { CONTRACT_SERIES } from 'constants/index';
import PasswdChecker from 'components/PasswdChecker';

import { TextField, PasswordField, SelectField } from '@avinfors/redux-form-fields';
import { required } from 'shared/validationFields';

class RegisterForm extends Component {
  render() {
    const { handleSubmit, submitOnEnter, error, password, submitting } = this.props;

    return (
      <Form onKeyDown={submitOnEnter(handleSubmit)} onSubmit={handleSubmit}>
        <Row form>
          <Col sm={4}>
            <FormGroup>
              <Label>Серия договора</Label>
              <div className='SelectFieldLg'>
                <Field
                  component={SelectField}
                  name='seria'
                  placeholder=''
                  validate={required.req}
                  options={CONTRACT_SERIES.map((s, i) => ({ code: i, name: s }))}
                />
              </div>
            </FormGroup>
          </Col>
          <Col sm={8}>
            <FormGroup>
              <Label>Номер договора</Label>
              <Field component={TextField} name='number' validate={required.req} bsSize='lg' />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <Label>Последние 4 цифры паспорта</Label>
          <Field
            component={TextField}
            name='passport'
            validate={required.req}
            bsSize='lg'
            maxLength='4'
          />
        </FormGroup>
        <FormGroup>
          <Label>Введите новый пароль</Label>
          <Field
            component={PasswordField}
            name='password'
            validate={required.req}
            bsSize='lg'
            buttonColor='success'
          />
          <PasswdChecker password={password} />
        </FormGroup>
        <FormGroup>
          <Label>Повторите новый пароль</Label>
          <Field
            component={PasswordField}
            name='password2'
            validate={required.req}
            bsSize='lg'
            buttonColor='success'
          />
        </FormGroup>
        <FormGroup>
          <div className='text-danger'>
            {error.split('\n').map((item, i) => {
              return <div key={i}>{item}</div>;
            })}
          </div>
        </FormGroup>
        <Button color='success' block onClick={handleSubmit} size='lg' disabled={submitting}>
          {submitting ? 'Подождите...' : 'Зарегистрироваться'}
        </Button>
      </Form>
    );
  }
}

RegisterForm.propTypes = {
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitOnEnter: PropTypes.func.isRequired,
  triggerPassRecoveryMode: PropTypes.func.isRequired,
  error: PropTypes.string
};

RegisterForm.defaultProps = {
  error: ''
};

const styles = theme => ({
  recoverLink: {
    color: '#8695a8',
    '&:hover': {
      color: '#3069B2'
    },
    cursor: 'pointer'
  }
});

const validate = values => {
  const errors = {};

  PasswdChecker.validate(errors, values);

  if (values.passport && !/^\d{4}$/.test(values.passport)) {
    errors.passport = 'введите 4 цифры';
  }
  return errors;
};

let RegisterFormRedux = reduxForm({
  form: 'registerForm',
  destroyOnUnmount: false,
  validate
})(RegisterForm);

const selector = formValueSelector('registerForm'); // <-- same as form name

export default compose(
  connect(state => {
    return {
      password: selector(state, 'password')
    };
  }),
  injectSheet(styles)
)(RegisterFormRedux);
